import { useContext } from 'preact/hooks';
import styleSheet from '../styles/selectorHeader.module.scss';
import { TeamSelectorContext } from '../teamSelector.component';
import { getImageUrl, onErrorImage } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for showing a SelectorHeader
 *
 * @returns {Element} <SelectorHeader />
 */
function SelectorHeader() {
    const { selector } = useContext(TeamSelectorContext);

    const TEAM_BADGE_WIDTH = 48;

    const homeTeamImageUrl = selector?.home_team_external_image_url
        ? selector?.home_team_external_image_url
        : getImageUrl(selector?.home_team_image_url, TEAM_BADGE_WIDTH);

    const awayTeamImageUrl = selector?.away_team_external_image_url
        ? selector?.away_team_external_image_url
        : getImageUrl(selector?.away_team_image_url, TEAM_BADGE_WIDTH);

    return (
        <>
            <div className={styles.selectorHeaderWrapper} part="ts-header">
                <div className={styles.selectorHeader}>
                    <style>{styleSheet.toString()}</style>
                    <div className={styles.selectorHeaderTitle}>
                        {selector?.title}
                    </div>
                    <div
                        className={styles.selectorHeaderTeams}
                        data-testid="team-badges"
                    >
                        <div className={styles.selectorHeaderTeamImage}>
                            <img
                                src={homeTeamImageUrl}
                                alt={`${selector?.home_team_name}`}
                                onError={onErrorImage}
                            />
                        </div>
                        <div className={styles.selectorHeaderText}>vs</div>
                        <div className={styles.selectorHeaderTeamImage}>
                            <img
                                src={awayTeamImageUrl}
                                alt={`${selector?.away_team_name}`}
                                onError={onErrorImage}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.selectorHeaderDescription}>
                    {selector?.description}
                </div>
            </div>
        </>
    );
}

export default SelectorHeader;
